export default __webpack_public_path__ + "static/media/actions-bsc.81816da3.svg";